import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { ToolsRecommendationComponent } from '../../tools/tools-recommendation.component';
import { SensePanelVM } from './sense-vm';

/** paid-s - SENSE (vision + hearing) results card. No score, no band, no gauge. */
@Component({
  selector: 'app-sense-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ToolsRecommendationComponent],
  templateUrl: './sense-panel.component.html',
})
export class SensePanelComponent {
  @Input() vm!: SensePanelVM;
  @Output() goPaywall = new EventEmitter<void>();
  /** empty state CTA: start the vision+hearing check (parent navigates to the sense test). */
  @Output() startCheck = new EventEmitter<void>();
  @Input() active = false;

  readonly chartW = 280;
  readonly chartH = 54;

  /** SVG polyline points string for one (gap-free) line segment. */
  pts(seg: { x: number; y: number }[]): string {
    return seg.map((p) => `${p.x},${p.y}`).join(' ');
  }
}
